import { fireStore } from '../../firebase'

export default ({
  state: {
    loading: false,
    error: null,
    customers: [],
    vehicles: []
  },
  mutations: {
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    clearError (state) {
      state.error = null
    },
    setCustomers (state, payload) {
      state.customers = payload
    },
    setVehicles (state, payload) {
      state.vehicles = payload
    },
    addVehicle (state, payload) {
      state.vehicles.push(payload)
    }
  },
  actions: {
    clearError ({ commit }) {
      commit('clearError')
    },
    setCustomers ({ commit }) {
      let customerArr = []
      fireStore.collection('Customers').get()
      .then(snap => {
        snap.forEach(doc => {
          const data = doc.data()
          const obj = {
            name: data.customerName,
            shortName: data.shortName,
            id: doc.id
          }
          customerArr.push(obj)
        })
        commit('setCustomers', customerArr)
      })
    },
    setVehicles ({ commit }) {
      let vehicleArr = []
      fireStore.collection('Vehicles').get()
      .then(snap => {
        snap.forEach(doc => {
          const data = doc.data()
          const obj = {
            Customer: data.Customer,
            Make: data.Make,
            Model: data.Model,
            VehicleReg: data.VehicleReg,
            Year: data.Year,
            id: doc.id,
            friendlyId: data.friendlyId
          }
          vehicleArr.push(obj)
        })
        commit('setVehicles', vehicleArr)
      })
    },
    addVehicle ({ commit }, payload) {
      commit('addVehicle', payload)
    }
  },
  getters: {
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    customers (state) {
      return state.customers
    },
    vehicles (state) {
      return state.vehicles
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/shared/index.js